module.exports = __webpack_public_path__ + "static/aboutbg2-56ab7b9380bfd51cd0696f89c59be21c.png";